module.exports = __webpack_public_path__ + "img/set-up-equipment.743f0718.svg";